var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7214 34.2979C8.51661 34.2979 1.05469 26.836 1.05469 17.6312C1.05469 8.42646 8.51661 0.964539 17.7214 0.964539C26.9261 0.964539 34.388 8.42646 34.388 17.6312C34.3779 26.8318 26.9219 34.2878 17.7214 34.2979ZM17.6947 30.9645H17.7214C25.0825 30.9572 31.045 24.9857 31.0414 17.6245C31.0377 10.2634 25.0692 4.29788 17.708 4.29788C10.3468 4.29788 4.37837 10.2634 4.37469 17.6245C4.37101 24.9857 10.3335 30.9572 17.6947 30.9645ZM14.388 25.9645L7.72135 19.2979L10.0714 16.9479L14.388 21.2479L25.3714 10.2645L27.7214 12.6312L14.388 25.9645Z",
    fill: "#2C2C44",
    stroke: "#2C2C44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnter);
export default __webpack_public_path__ + "static/media/icon-enter.76d72b10fbb55be9dbc8087417fc6049.svg";
export { ForwardRef as ReactComponent };